import _ from 'lodash'
import defaultConfig from './channels/default'
import cookie from 'cookie'
import { query } from 'qs'
const build = (name, channel) => {
  const userAgent = navigator.userAgent
  return _.merge({}, defaultConfig, {
    name,
    match () {
      return userAgent.indexOf(channel) !== -1 || query.channel === channel || cookie.get('channel') === channel
    }
  })
}

const configs = [
  ['114生活助手', '114'],
  ['保定通', 'baodingtong'],
  ['北京LOOK', 'BJ_LOOK'],
  ['保+保', 'baojiabao'],
  ['飞渔旅游', 'feiyulvyou'],
  ['Fit去动', 'fit'],
  ['信必睿', 'xinbirui'],
  ['浦发银行', 'spdbbank'],
  ['同程公众号', 'tongcheng'],
  ['同程APP', 'tongchengapp'],
	['达州通','dazhoutong'],
	['袋鼠妈妈','dsmm'],
	['美付宝','gomepay'],
	['K米','kmi'],
	['全民吃瓜','qmcg'],
	['亿起发','yiqifa'],
	['电影头条', 'dytt'],
  ['微珠宝', 'weizhubao']
]

export const channels = configs.map((config) => {
  return build.apply(null, config)
})



// WEBPACK FOOTER //
// ./src/mods/commonH5Channels.js